import { Image, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';

import RichTextWrapper from 'components/helpers/RichText/RichTextWrapper';
import classNames from 'classnames/bind';
import withStyles from 'lib/enhancers/withStyles';
import compose from 'lib/enhancers/compose';
import styles from './Blog.module.scss';
import { BlogDetailsProps } from 'models/blog-types';
import BlogTopicsList from './BlogTopicsList';
import BlogPublishedOn from './BlogPublishedOn';
import BlogAuthorLink from './BlogAuthorLink';
import { fixMediaImagePath } from 'lib/utils';

const cx = classNames.bind(styles);

// See same implementation in PodcastListing.tsx
const BlogDetails = (props: BlogDetailsProps): React.JSX.Element => {
  const { className, fields } = props;
  const { blogHeading, blogSubHeading, blogTopics, blogPhoto, blogPost, blogDisclaimerText } = fields;
  const blogHeadingLevelValue = 'h1';
  const blogSubHeadingLevelValue = 'h2';

  const { sitecoreContext } = useSitecoreContext();
  const { language } = sitecoreContext;

  const photo = fixMediaImagePath(blogPhoto);

  return (
    <article className={cx('blog-details', className)}>
      <header>
        <Text
          tag={blogHeadingLevelValue}
          field={blogHeading}
          className={cx('blog-details__heading')}
          encode={sitecoreContext.pageEditing}
        />

        <BlogAuthorLink blogDetails={fields} language={language} className="blog-details__authorInfo" />
        <BlogPublishedOn blogDetails={fields} language={language} className="blog-details__published" />

        <BlogTopicsList blogTopics={blogTopics} language={language} className="blog-details__blogTopic" />
      </header>

      <div className={cx('blog-details__content')}>
        <div className={cx('blog-details__photo')}>
          <Image field={photo} />
        </div>

        <Text
          tag={blogSubHeadingLevelValue}
          field={blogSubHeading}
          className={cx('blog-details__subheading')}
          encode={sitecoreContext.pageEditing}
        />

        <RichTextWrapper field={blogPost} />
        <RichTextWrapper field={blogDisclaimerText} className={cx('blog-details__disclaimer')} />
      </div>
    </article>
  );
};

export default compose<BlogDetailsProps>(withStyles())(BlogDetails);
